import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import FolderIcon from '@mui/icons-material/Folder';
import { TreeItemProps, TreeView } from '@mui/lab';
import React from 'react';
import { ITreeItem } from './TreeItem';
import { TreeViewItem } from './TreeViewItem';
export interface IBinderTreeView {
  expanded: string[];
  toggle: (_event: React.SyntheticEvent<Element, Event>, nodeIds: string[]) => void;
  treeitemclick: (nodeId: string) => void;
  treeViewData: ITreeItem[];
}


export const TreeViewComponent: React.FC<IBinderTreeView> = ({ expanded, toggle, treeitemclick, treeViewData }) => {
  return (
    <TreeView
      aria-label="Binder Viewer"
      expanded={expanded}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}
      sx={{ ml: -1, mr: 1 }}
      onNodeToggle={toggle}
    >
      {treeViewData.map((item, i)=><TreeViewItem key={i} {...item} treeitemclick={treeitemclick} />)}
      
    </TreeView>
  );
};
